import { render } from "./StartScreenImg.vue?vue&type=template&id=26beed9f&scoped=true"
import script from "./StartScreenImg.vue?vue&type=script&lang=js"
export * from "./StartScreenImg.vue?vue&type=script&lang=js"

import "./StartScreenImg.vue?vue&type=style&index=0&id=26beed9f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26beed9f"]])

export default __exports__